import { useTranslation } from "react-i18next";

import React from "react";
import CloseSvg from './assets/close.svg';

import { PopUpProps } from "./PopUp.types";

import "./PopUp.scss";

export const PopUp: React.FC<PopUpProps> = ({ type, onClose, children }) => {
  const { t } = useTranslation();
  return(
    <div className={'pop-up'}>
        <div className={'header'}>
            <button type={'button'} className={'close-btn'} onClick={() => onClose()}>
                <img src={CloseSvg}/>
            </button>
            <span className={'popup-type'}>
                {t(type)}
            </span>
        </div>
        <div className={'content'}>
            {children}
        </div>
    </div>
  )
};

